import { useEffect, useRef } from 'react';

import { setAppStore } from '@/store';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import getScreenType from '@/utils/analytics/getScreenType';
import getCurrentUserId from '@/utils/user/getCurrentUserId';
import { AiGenScreenAction } from '@/types/analytics';

import {
  loadAnnouncedClaimId,
  saveAnnouncedClaimId,
} from '../storage/claimAnnouncementStorage';
import useFreePassEnabled from './useFreePassEnabled';
import useStreakState from './useStreakState';

const useStreakAutoOpen = () => {
  const enabled = useFreePassEnabled();
  const { streak, promo, isReady } = useStreakState();
  const announcedRef = useRef<string | null>(null);

  useEffect(() => {
    const isClaimReady =
      enabled && isReady && streak.canClaim && Boolean(promo);
    if (!isClaimReady || !promo) return;

    const claimId = `${getCurrentUserId()}:${promo.id}:${
      streak.currentDayNumber
    }`;
    const wasAnnounced =
      announcedRef.current === claimId || loadAnnouncedClaimId() === claimId;
    if (wasAnnounced) return;

    announcedRef.current = claimId;
    saveAnnouncedClaimId(claimId);
    setAppStore({ isStreakSheetOpen: true });
    sendAiGenScreenActionAnalytics({
      action: AiGenScreenAction.STREAK_AUTO_OPEN,
      screen_type: getScreenType(),
    });
  }, [
    enabled,
    isReady,
    promo,
    streak.canClaim,
    streak.currentDayNumber,
    streak.sheetMode,
  ]);
};

export default useStreakAutoOpen;
